import { AppLayoutBreakpoint } from '../../../util/responsiveness';

import { useAppLayoutContext, useAppLayoutWidth } from './useAppLayoutContext';

export const collapsedLeftNavWidth = 64;
const largeWidth = 360;
const mediumWidth = 320;
const smallWidth = 260;

/**
 * Provides the width of the leftnav based on the current app layout width.
 * When the leftnav is collapsed, returns the fixed collapsed (icon-only) rail width.
 */
export const useLeftNavWidth = (): number => {
  const layoutWidth = useAppLayoutWidth();
  const isCollapsed = useAppLayoutContext()?.isLeftNavCollapsed ?? false;

  if (isCollapsed) {
    return collapsedLeftNavWidth;
  }

  if (layoutWidth > AppLayoutBreakpoint.Width1352) {
    return largeWidth;
  }

  if (layoutWidth > AppLayoutBreakpoint.Width1292) {
    return mediumWidth;
  }

  return smallWidth;
};
